<template>
  <Card class="box-card">
    <Tabs v-model="menuCurrentName" @on-click="changeMenuCurrent">
      <TabPane :name="item.name" :label="item.label" v-for="(item, index) in menuList" :key="index" class="tabs-style">
        <Row>
          <Col :span="6" style="margin: 0 10px 0 0">
            <Card>
              <p>帮扶记录总数</p>
              <p>
                <span style="color: #aaa; padding-right: 4px">{{ startAt1 }}</span>
                <strong style="font-size: 20px">{{ cardList.jobHelpCount }}</strong>
                条
              </p>
              <p>
                <span style="color: #aaa; padding-right: 4px">{{ startAt2 }}</span>
                <strong>{{ cardList.jobHelpCountYesterday }}</strong>
                条
                <strong style="color: #d6000f">
                  {{
                    cardList.jobHelpCountIncrease > 0 ? '+' + cardList.jobHelpCountIncrease : cardList.jobHelpCountIncrease
                  }}&nbsp;&nbsp;（{{
                    cardList.jobHelpCountIncreaseRate > 0
                      ? '+' + cardList.jobHelpCountIncreaseRate + '%'
                      : cardList.jobHelpCountIncreaseRate + '%'
                  }}）
                </strong>
              </p>
            </Card>
          </Col>
          <Col :span="6" style="margin: 0 10px 0 0">
            <Card>
              <p>求职者入职总数</p>
              <p>
                <span style="color: #aaa; padding-right: 4px">{{ startAt1 }}</span>
                <strong style="font-size: 20px">{{ cardList.jobEntryCount }}</strong>
                人
              </p>
              <p>
                <span style="color: #aaa; padding-right: 4px">{{ startAt2 }}</span>
                <strong>{{ cardList.jobEntryCountYesterday }}</strong>
                人
                <strong style="color: #d6000f">
                  {{
                    cardList.jobEntryCountIncrease > 0 ? '+' + cardList.jobEntryCountIncrease : cardList.jobEntryCountIncrease
                  }}&nbsp;&nbsp;（{{
                    cardList.jobEntryCountIncreaseRate > 0
                      ? '+' + cardList.jobEntryCountIncreaseRate + '%'
                      : cardList.jobEntryCountIncreaseRate + '%'
                  }}）
                </strong>
              </p>
            </Card>
          </Col>
        </Row>

        <Row type="flex" justify="space-around" style="margin: 20px 0 0" :ref="item.name + '-chartContainer'" @resize="handleResize">
          <Col :sm="12" :xs="24" style="box-sizing: border-box; padding: 0 5px">
            <Card style="width: 100%; height: 300px">
              <chartLine :chartId="item.name + '-record'" :ref="item.name + '-record'" :chartData="chatLine" />
            </Card>
          </Col>
          <Col :sm="12" :xs="24" style="box-sizing: border-box; padding: 0 5px">
            <Card style="width: 100%; height: 300px">
              <chartLine :chartId="item.name + '-entry'" :ref="item.name + '-entry'" :chartData="chatLine1" />
            </Card>
          </Col>
        </Row>
      </TabPane>
    </Tabs>
  </Card>
</template>

<script>
import chartLine from './components/chart-line.vue';
import debounce from 'lodash/debounce';
import dayjs from 'dayjs';
export default {
  name: 'HelpDatas',
  components: { chartLine },
  data() {
    return {
      menuCurrentName: '1',
      menuList: [],
      cardList: {
        jobHelpCount: 0,
        jobHelpCountYesterday: 0,
        jobHelpCountIncrease: 0,
        jobHelpCountIncreaseRate: 0,
        jobEntryCount: 0,
        jobEntryCountYesterday: 0,
        jobEntryCountIncrease: 0,
        jobEntryCountIncreaseRate: 0
      },
      resizeObserver: null,
      startAt: '',
      endAt: '',
      chatLine: [],
      chatLine1: [],
      list: [],
      startAt1: '',
      startAt2: ''
    };
  },
  mounted() {
    this.helpPlan();
    this.startAt = dayjs().add(-31, 'day').format('YYYY-MM-DD');
    this.endAt = dayjs().add(-1, 'day').format('YYYY-MM-DD');
    this.startAt1 = dayjs().add(-1, 'day').format('MM月DD日');
    this.startAt2 = dayjs().add(-2, 'day').format('MM月DD日');
    // this.$nextTick(() => {
    //   this.initChart();
    // });
  },
  methods: {
    helpPlan() {
      this.$axios
        .request({
          url: 'front/v1/help-plan',
          method: 'get',
          params: { pageIndex: 1, pageSize: 100 }
        })
        .then(res => {
          let data = res.data.list || [];
          data.map(item => {
            this.menuList.push({ label: item.name, name: item.id + '' });
          });
          if (data.length) {
            this.menuCurrentName = this.menuList[0].name;
            this.getDaily();
          }
        });
    },
    getDaily() {
      this.chatLine = [];
      this.chatLine1 = [];
      this.$axios
        .request({
          url: 'front/v1/statistics/help/company',
          method: 'get',
          params: { helpType: this.menuCurrentName, startAt: this.startAt, endAt: this.endAt }
        })
        .then(res => {
          let data = res.data.list || [];
          data.map(item => {
            this.chatLine.push({ count: item.jobHelpCount, time: dayjs(item.timestamp).format('MM-DD') });
            this.chatLine1.push({ count: item.jobEntryCount, time: dayjs(item.timestamp).format('MM-DD') });
          });
          if (data.length) {
            if (data[data.length - 1] && dayjs(data[data.length - 1].timestamp).format('YYYY-MM-DD') === this.endAt) {
              this.cardList = data[data.length - 1];
            } else {
              this.startAt1 = dayjs(data[data.length - 1].timestamp).format('MM月DD日');
              let yesday = dayjs(data[data.length - 1].timestamp)
                .format('YYYY-MM-DD')
                .subtract(1, 'day');
              this.startAt2 = yesday.format('MM月DD日');
              this.cardList = data[data.length - 1];
            }
            
          } else {
            this.cardList = {
              jobHelpCount: '-',
              jobHelpCountYesterday: '-',
              jobHelpCountIncrease: '-',
              jobHelpCountIncreaseRate: '-',
              jobEntryCount: '-',
              jobEntryCountYesterday: '-',
              jobEntryCountIncrease: '-',
              jobEntryCountIncreaseRate: '-'
            };
          }

          // this.setOption(res.data);
        });
    },
    initChart() {
      this.resizeObserver = new ResizeObserver(entries => {
        this.handleResize(entries[0].contentRect);
      });

      this.$once('hook:beforeDestroy', () => {
        this.resizeObserver.disconnect();
      });

      // this.changeMenuCurrent();
    },

    handleResize: debounce(function (rect) {
      console.log(`宽度：${rect.width}px，高度：${rect.height}px`);
      this.$refs[this.menuCurrentName + '-record'][0].resize();
      this.$refs[this.menuCurrentName + '-entry'][0].resize();
    }, 200),

    changeMenuCurrent() {
      this.getDaily();
      // this.$refs[this.menuCurrentName + '-record'][0].setOption();
      // this.$refs[this.menuCurrentName + '-entry'][0].setOption();
      // this.resizeObserver.observe(this.$refs[this.menuCurrentName + '-chartContainer'][0].$el);
    }
  }
};
</script>
